module.exports = __webpack_public_path__ + "static/img/login_bg.24a5ecc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/login_bg.png
// module id = TGON
// module chunks = 66